import { getChatRequestUrl, getColourAnalysisRequestUrl } from '../config';
import { authedFetch } from './authedRequest';

export async function lookupShadeProductLines(brand) {
  const colourJourney = process.env.REACT_APP_ENABLE_COLOUR_ANALYSIS === 'true'
    && typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('from') === 'colour-analysis';
  const response = await authedFetch(colourJourney ? getColourAnalysisRequestUrl() : getChatRequestUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lookupShadeProductLines: { brand } }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.message || 'Product search is unavailable');
  return payload;
}
